import './styles.scss';
import { FC } from 'react';
import { ModalRecoveryDeletedTicketInterface } from './indexModel';
import { Modal } from 'react-bootstrap';
import { IconX } from '@tabler/icons-react';
import Loading from '../../../../../components/loading2';

const ModalRecoveryDeletedTicket: FC<ModalRecoveryDeletedTicketInterface> = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={() => props.hide(false)}
      aria-labelledby=""
      size="sm"
      centered={true}
      dialogClassName="modal-recovery-deleted-ticket-component"
    >
      <Modal.Header>
        <Modal.Title>
          {props.t('title')}
        </Modal.Title>
        <div className="modal-recovery-deleted-ticket-header-actions">
          <IconX onClick={() => props.hide(false)} />
        </div>
      </Modal.Header>
      <Modal.Body>
        { (!props.data || props.loadingRecoveryDeletedTicket) && <Loading blur={true}/>}
        { props.data &&
          <span className="modal-recovery-deleted-ticket-message">
            {props.t('message_1')} <span>#{props.data.ticketReferenceId}</span>. {props.t('message_2')}
          </span>
        }
      </Modal.Body>
      <Modal.Footer>
        <button className='modal-recovery-deleted-ticket-btn-cancel' onClick={() => props.hide(false)}>{props.t('btn_cancel')}</button>
        <button className='modal-recovery-deleted-ticket-btn-save' disabled={props.loadingRecoveryDeletedTicket} onClick={() => props.handleSubmit()}>{props.t('btn_recovery')}</button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalRecoveryDeletedTicket;
